<template>
<div class="row landing-cnt panel-cnt">
		<base-dialog v-model="show360DecisionModal" :content="$t('patient-panel.go-360-decision')"
			:okBtnText="$t('patient-panel.go-360')" :cancelBtnText="$t('patient-panel.stay-opensalud')"
			:okFn="() => { goTo360() }" :cancelFn="() => { app360DecisionModalForceHide = true }" cancelBtnVariant="info">
		</base-dialog>

    <!-- <div class="bg-heart d-none d-xl-block"></div> -->
        <!-- Main block logged -->
    <div class="col-12 col-lg-6 my-lg-auto my-0 logged-ctn">
        <div class="logged-title-ctn mb-5">
            <h1 class="mb-4">{{ $t('patient-panel.welcome', { platform: getPlatformName }) }}</h1>
            <h3 class="blue">
            {{ $t('patient-panel.what-do-you-need') }}
            </h3>
        </div>
        <SimpleSearch :search360="show360Search"/>
				<BackButton class="mt-3"/>
    </div>
</div>
</template>

<script>
import { getPlatformName, inOpensalud360 } from '@/constants/platformNames'
import BaseDialog from '@/components/base/BaseDialog.vue'
import SimpleSearch from '@/components/shared/SimpleSearch.vue'
import BackButton from '@/components/base/buttons/BackButton'

export default {
	components: {
		BaseDialog,
		SimpleSearch,
		BackButton
	},
	props: {
		companiesActive: {
			type: Boolean,
			required: false,
			default () {
					return this.$store.state.session.user ? this.$store.state.session.user.companiesActive : false
			}
		}
	},
	data () {
			return {
					getPlatformName: getPlatformName(),
					inOpensalud360,
					app360DecisionModalForceHide: false
			}
	},
	methods: {
			goTo360 () {
					window.location.href = this.$helpers.get360AppUrl('patient/panel-search')
			}
	},
	computed: {
		show360Search () {
				return inOpensalud360() && this.companiesActive
		},
		show360DecisionModal: {
			get () {
				return this.companiesActive && !inOpensalud360() && !this.app360DecisionModalForceHide && this.$store.getters['session/search360Active']
			},
			set (value) {
				if (value) {
						this.app360DecisionModalForceHide = true
				}
			}
		}
	},
	created () {
		this.app360DecisionModalForceHide = false
	}
}
</script>

<style lang="scss" scoped>
    @import "static-appopensalud/css/public/views/360.scss";
    .search-type{
        display: flex;
        gap: 1rem;
        // @include media(mobile) {
        //     flex-direction: column;
        // } 
    }
    .photo-option{
        border-radius: 100%;
        padding: 0;
        width: 30px;
        height: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/PanelSearch.vue